import { render, staticRenderFns } from "./Utmify.vue?vue&type=template&id=335c40a3&"
import script from "./Utmify.vue?vue&type=script&lang=js&"
export * from "./Utmify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports